<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4.16669V15.8334" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.16663 10H15.8333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
